import {
   Box,
   Grid,
   List,
   ListItem,
   ListItemText,
   TextField,
   Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { sizes } from "../setupUtils";
import dayjs from "dayjs";
import { setCGState } from "./customerGroupSetupSlice";
import { useEffect } from "react";

export default function EditIndividualCustomerDate() {
   const dispatch = useDispatch();
   const cgState = useSelector((store) => store.customerGroupSetup);
   const { selCustomers, editFromDate, editToDate } = cgState;

   const minDate = dayjs().add(1, "day");

   useEffect(() => {
      setInitialDate();
   }, []);

   function setInitialDate() {
      const selected = selCustomers.map((item) => {
         if (
            item.hasOwnProperty("effectiveStartDate") &&
            item.hasOwnProperty("effectiveEndDate")
         ) {
            return item;
         }
         return {
            ...item,
            effectiveStartDate: editFromDate,
            effectiveEndDate: editToDate,
         };
      });
      console.log("setInitialDate", selected);
      dispatch(setCGState("selCustomers", selected));
   }

   function updateFromDate(date, customerID) {
      const selected = selCustomers.map((item) => {
         if (item.customerID === customerID) {
            return {
               ...item,
               effectiveStartDate: date,
            };
         }
         return item;
      });
      console.log("updateFromDate", selected);
      dispatch(setCGState("selCustomers", selected));
   }

   function updateToDate(date, customerID) {
      const selected = selCustomers.map((item) => {
         if (item.customerID === customerID) {
            return {
               ...item,
               effectiveEndDate: date,
            };
         }
         return item;
      });
      dispatch(setCGState("selCustomers", selected));
   }

   return (
      <Box sx={{ mt: 4 }}>
         <Box
            sx={{
               bgcolor: "blue.light",
               height: 40,
               pl: 1,
               pt: 1,
               borderRadius: 1,
            }}
         >
            <Typography sx={{ fontWeight: "bold" }}>Customers</Typography>
         </Box>
         <Box
            sx={{
               height: 360,
               overflow: "auto",
            }}
         >
            {selCustomers.map((customer, index) => {
               return (
                  <Grid container columnSpacing={1} sx={{ mt: 1 }} key={index}>
                     <Grid item xs={8}>
                        <Typography variant="p16w400">
                           {customer.customerName}
                        </Typography>
                     </Grid>

                     <Grid item xs={2}>
                        <Box>
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                 minDate={minDate}
                                 label="From"
                                 value={dayjs(customer.effectiveStartDate)}
                                 onChange={(newDate) =>
                                    updateFromDate(newDate, customer.customerID)
                                 }
                                 format="DD/MM/YYYY"
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       size="small"
                                       sx={{ width: sizes.w150 }}
                                    />
                                 )}
                              />
                           </LocalizationProvider>
                        </Box>
                     </Grid>

                     <Grid item xs={2}>
                        <Box sx={{ mr: 0.5 }}>
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                 minDate={minDate}
                                 label="To"
                                 value={dayjs(customer.effectiveEndDate)}
                                 onChange={(newDate) =>
                                    updateToDate(newDate, customer.customerID)
                                 }
                                 format="DD/MM/YYYY"
                                 renderInput={(params) => (
                                    <TextField
                                       {...params}
                                       size="small"
                                       sx={{ width: sizes.w150 }}
                                    />
                                 )}
                              />
                           </LocalizationProvider>
                        </Box>
                     </Grid>
                  </Grid>
               );
            })}
         </Box>
      </Box>
   );
}
